module.exports = __webpack_public_path__ + "e93f9dd66626c96033df846ac5e71e92.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-2.png
// module id = 2597
// module chunks = 0